import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class VowelExceptionShortSoundMark extends Mark implements IMark
{
    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 56;
        this.markHeight = 10;
        this.strokeThickness = 5;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
            this.padding = this.adjustToScale(26);
            this.markX = this.targetTextField.width/2;
            this.markY = this.adjustToScale(78);
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)*this.strokeMultipleOfText;
            if(this.targetTextField.text == "i")
            {
                this.padding = this.adjustToScale(2);
                this.markY = this.adjustToScale(30);
            }
            this.markWidth = this.targetTextField.width-(this.padding*2);
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const charWidth = this.markWidth-10;
        let grWidth = this.markWidth;//charWidth * .6;
        let shortHeight = this.markHeight;

        let mark = new Container();

        let gr = new Graphics();
        gr.moveTo(0, 0);
        gr.quadraticCurveTo((grWidth / shortHeight), shortHeight, (grWidth / 2), shortHeight);
        gr.quadraticCurveTo(grWidth - (grWidth / shortHeight), shortHeight, grWidth, 0);
        gr.stroke({color:color, width:this.strokeThickness, cap:"round"});
        mark.addChild(gr);

        gr = new Graphics();
        gr.moveTo(0, shortHeight + 8 + this.strokeThickness / 2);
        gr.lineTo(grWidth, shortHeight + 8 + this.strokeThickness / 2);
        gr.stroke({color:color, width:this.strokeThickness, cap:"round"});
        mark.addChild(gr);

        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}